import { render, staticRenderFns } from "./HeaderCarousel.vue?vue&type=template&id=fd150b0a&scoped=true"
import script from "./HeaderCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderCarousel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderCarousel.vue?vue&type=style&index=0&id=fd150b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd150b0a",
  null
  
)

export default component.exports